import { useAuth } from '@/hooks/useAuth';
import { usePermition } from '@/hooks/usePermition';
import { menuItems } from '@/components/SideMenu';
import { Center, Spinner } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Page404 } from '../Error/404';
import { isRouteAllowed } from './isRouteAllowed';

interface ProtectedRouteProps {
  children: ReactElement;
}

export function ProtectedRoute({
  children,
}: ProtectedRouteProps): ReactElement {
  const { signed } = useAuth();
  const { pathname } = useLocation();
  const { menus, isLoading } = usePermition();

  if (!signed) {
    return <Navigate to="/signin" replace />;
  }

  if (isLoading) {
    return (
      <Center minH="100vh">
        <Spinner size="xl" color="#0f4f6d" />
      </Center>
    );
  }

  if (!isRouteAllowed(pathname, menus, menuItems)) {
    return <Page404 />;
  }

  return children;
}
